import React from 'react';
import { styled } from 'styled-components';
import { StyledRow } from './AvailabilityTable/styled.ts';

const StyledButton = styled.button`
  color: #fff;
  background: #fdb45d;
  padding: 5px 15px;
  position: relative;
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 25px;
  text-shadow: none;
  border: 0;
  border-radius: 2px;
  overflow: hidden;
  cursor: pointer;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.15),
    0 1px 1px rgba(0, 0, 0, 0.075);

  &:hover,
  &:active,
  &:focus {
    background: #f9a825;
  }

  &:after {
    position: absolute;
    top: -50px;
    left: -75px;
    z-index: 2;
    width: 50px;
    height: 155px;
    background: #fff;
    content: '';
    opacity: 0.2;
    transform: skewX(30deg);
    transition: 0.5s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.5, 1);
  }

  &:hover:not(:disabled)::after {
    left: 160%;
  }

  &:disabled {
    background: gray;
    cursor: default;
  }
`;

interface CheckAvailabilityButtonProps {
  getAllLiveAvailability: () => void;
  isDisabled: boolean;
}

const CheckAvailabilityButton: React.FC<CheckAvailabilityButtonProps> = ({
  getAllLiveAvailability,
  isDisabled,
}) => (
  <StyledRow>
    <div className="col-md-12">
      <StyledButton type="button" onClick={() => getAllLiveAvailability()} disabled={isDisabled}>
        CHECK ALL AVAILABILITY
      </StyledButton>
    </div>
  </StyledRow>
);

export default CheckAvailabilityButton;
